import React, { useEffect, useState } from "react";
import { compose } from "redux";

import { borrowerWithdrawalConnector } from "../../../../services/orders/userProfile/borrowerWithdrawalConnector";
import TableNew, { CELL_TYPES } from "../../../../shared/Table";

import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

export const BorrowerWithdrawalComponent = ({
  currentUser,
  getBorrowerDepot,
  createBorrowerWithdrawal,
  depot,
  withdrawals,
  getWithdrawals,
  confirmWithdrawal,
}) => {
  const [account, setAccount] = useState("");
  const [orderNotes, setOrderNotes] = useState("");

  useEffect(() => {
    if (!depot.data[currentUser.Id])
      getBorrowerDepot(currentUser.Id, currentUser.Depots[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser.Id]);
  useEffect(() => {
    if (!withdrawals || !withdrawals.data[currentUser.Id])
      getWithdrawals(currentUser.Id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser.Id]);

  const createOrderTable = () => {
    if (
      !withdrawals.data[currentUser.Id] ||
      withdrawals.data[currentUser.Id].length == 0
    )
      return undefined;

    const tableColumns = [
      {
        key: "Created",
        label: "Created",
        visible: true,
        type: CELL_TYPES.text,
      },
      { key: "Id", label: "Id", visible: true, type: CELL_TYPES.text },
      {
        key: "Amount",
        label: "Amount",
        visible: true,
        type: CELL_TYPES.number,
      },
      {
        key: "BankAccountNumber",
        label: "AccNo",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "BankAccountBank",
        label: "Bank",
        visible: true,
        type: CELL_TYPES.text,
      },
      { key: "Notes", label: "Notes", visible: true, type: CELL_TYPES.text },
      {
        key: "actions",
        label: "Actions",
        visible: true,
        renderer: (value, item) => {
          return (
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                confirmWithdrawal(
                  currentUser.Id,
                  currentUser.Depots[0],
                  item.Id,
                )
              }
              disabled={item.Executed}
            >
              {item.Executed ? "Confirmed" : "Confirm"}
            </Button>
          );
        },
      },
    ];

    return (
      <TableNew
        columns={tableColumns}
        items={withdrawals.data[currentUser.Id]}
        tableKey={"borrowerWithdrawalOrders-" + currentUser.Id}
        actionColumnWidth={140}
      />
    );
  };

  if (!depot.data[currentUser.Id]) return <div>Loading excess payments...</div>;

  const selectBankAccount = (
    <Select
      value={account}
      onChange={(e) => setAccount(e.target.value)}
      label="Account"
    >
      {currentUser.BankAccounts.map((account) => {
        return (
          <MenuItem key={account.Id} value={account.Id}>
            {" "}
            {account.Number + " (" + account.BankName + ")"}{" "}
          </MenuItem>
        );
      })}
    </Select>
  );

  const currentDepot = depot.data[currentUser.Id][0];
  const hasExcessBalance = currentDepot.Balance.Amount > 0;
  const displayStyle = { display: hasExcessBalance ? "block" : "none" };

  const withdrawalForm = hasExcessBalance ? (
    <React.Fragment>
      <ul className="basic">
        <li style={displayStyle}>
          Excess Amount: {currentDepot.Balance.Amount} <br />
        </li>
        <div style={displayStyle}>
          <div>Select bankaccount: {selectBankAccount}</div>
          <div>
            Notes:{" "}
            <TextField
              onChange={(e) => setOrderNotes(e.target.value)}
            ></TextField>
          </div>
          <div>
            <Button
              variant="contained"
              className="button-margin"
              onClick={() => {
                createBorrowerWithdrawal(
                  currentUser.Id,
                  account,
                  currentDepot.Balance.Amount,
                  orderNotes,
                );
              }}
            >
              Withdraw
            </Button>
          </div>
        </div>
        <hr style={displayStyle} />
      </ul>
    </React.Fragment>
  ) : (
    <div>Borrower has no excess payments</div>
  );

  return (
    <div className="borrower-withdrawal-base">
      <h4>Withdraw excess payment</h4>
      {withdrawalForm}
      {createOrderTable()}
    </div>
  );
};

export default compose(borrowerWithdrawalConnector)(
  BorrowerWithdrawalComponent,
);
